import { render, staticRenderFns } from "./UserFamily.vue?vue&type=template&id=5d46b9fd&"
import script from "./UserFamily.vue?vue&type=script&lang=js&"
export * from "./UserFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports